import { render, staticRenderFns } from "./VModalTable.vue?vue&type=template&id=339f18b3&scoped=true&functional=true&"
import script from "./VModalTable.vue?vue&type=script&lang=js&"
export * from "./VModalTable.vue?vue&type=script&lang=js&"
import style0 from "./VModalTable.vue?vue&type=style&index=0&id=339f18b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "339f18b3",
  null
  
)

export default component.exports